/**
 * Casa Platino — Product page renderer
 * Reads inline JSON from <script id="cp-product-data">,
 * builds size/color selectors, accordion, related grid.
 */
(function () {
  // Match a product handle (or substring) to a size-guide key in cp-size-guide.js
  var SIZE_GUIDE_BY_HANDLE = [
    { match: 'egyptian-cotton-sheet-set-1000-thread-count', key: 'egyptian-cotton-1000tc' },
    { match: '450-thread-count-sheet-set',                  key: '450tc-cotton' },
    { match: '600-thread-count-sheet-set',                  key: '600tc-cotton' },
    { match: 'percale-cotton-sheet-set',                    key: 'percale-cotton' },
    { match: 'flannel-sheet-set',                           key: 'flannel-cotton' },
    { match: 'washed-microfiber-sheet-set',                 key: 'microfiber' }
  ];
  function sizeGuideKeyFor(handle) {
    if (!handle) return null;
    for (var i = 0; i < SIZE_GUIDE_BY_HANDLE.length; i++) {
      if (handle.indexOf(SIZE_GUIDE_BY_HANDLE[i].match) !== -1) return SIZE_GUIDE_BY_HANDLE[i].key;
    }
    return null;
  }

  var P = null;
  var CURRENT_SIZE = null;
  var CURRENT_COLOR = null;
  var VARIANTS_BY_KEY = {};   // "size|color" -> variant
  var SIZES_ORDERED = [];
  var COLORS_BY_SIZE = {};    // size -> [colors]

  function $(id) { return document.getElementById(id); }

  function init() {
    var node = $('cp-product-data');
    if (!node) return;
    try { P = JSON.parse(node.textContent); }
    catch (e) { console.error('cp-product: bad JSON', e); return; }

    indexVariants();

    selectInitialVariant();

    renderGallery();
    renderSizeSelector();
    renderColorSelector();
    renderAccordion();
    renderRelated();
    updatePrice();
    updateMainImage();
    bindQuantityButtons();
  }

  function indexVariants() {
    var sizeOrder = ['Twin', 'Twin XL', 'Twin-XL', 'Twin-Xl', 'Twin Xl', 'Full', 'Queen', 'King', 'Calking', 'California King', 'Split King', '2 Pack', '4 Pack', '6 Pack', '8 Pack', '12 Pack', '18 Pack', '20 Pack', '24 Pack'];
    var sizes = new Set();
    (P.variants || []).forEach(function (v) {
      var size = v.size || 'Default';
      var color = v.color || 'Default';
      var key = size + '|' + color;
      VARIANTS_BY_KEY[key] = v;
      sizes.add(size);
      if (!COLORS_BY_SIZE[size]) COLORS_BY_SIZE[size] = [];
      if (COLORS_BY_SIZE[size].indexOf(color) === -1) COLORS_BY_SIZE[size].push(color);
    });
    SIZES_ORDERED = Array.from(sizes).sort(function (a, b) {
      var ai = sizeOrder.indexOf(a);
      var bi = sizeOrder.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }

  function currentVariant() {
    return VARIANTS_BY_KEY[CURRENT_SIZE + '|' + CURRENT_COLOR] || null;
  }

  function selectInitialVariant() {
    var linked = variantFromOptionsUrl() || variantFromUrl();
    if (linked) {
      CURRENT_SIZE = linked.size || 'Default';
      CURRENT_COLOR = linked.color || 'Default';
      return;
    }

    CURRENT_SIZE = SIZES_ORDERED[0] || null;
    CURRENT_COLOR = (COLORS_BY_SIZE[CURRENT_SIZE] || [])[0] || null;
  }

  function variantFromOptionsUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var size = params.get('size');
      var color = params.get('color');
      if (!size || !color) return null;

      return (P.variants || []).filter(function (v) {
        return normalizeTag(v.size || 'Default') === normalizeTag(size) &&
          normalizeTag(v.color || 'Default') === normalizeTag(color);
      })[0] || null;
    } catch (e) {
      return null;
    }
  }

  function variantFromUrl() {
    try {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (!id) return null;
      return (P.variants || []).filter(function (v) {
        return String(v.id) === String(id);
      })[0] || null;
    } catch (e) {
      return null;
    }
  }

  function galleryImagesForCurrentSelection() {
    var imgs = [];
    var seen = new Set();
    var taggedCount = 0;

    function add(media) {
      var url = imageUrl(media);
      if (!url || seen.has(url)) return;
      seen.add(url);
      imgs.push(normalizeImage(media));
    }

    function addTagged(media) {
      if (!imageMatchesSelection(media)) return;
      add(media);
      taggedCount++;
    }

    var selected = currentVariant();
    if (selected && selected.image) add(selected.image);

    (P.images || []).forEach(addTagged);

    if (taggedCount === 0) {
      (P.variants || []).forEach(function (v) {
        if ((v.color || 'Default') === CURRENT_COLOR) add(v.image);
      });
    }

    if (imgs.length === 0) {
      (P.images || []).forEach(add);
    }

    return imgs.slice(0, 8);
  }

  function normalizeImage(media) {
    if (typeof media === 'string') return { url: media, alt: P.title || '' };
    var alt = media && media.alt ? media.alt : P.title || '';
    return {
      url: media && media.url ? media.url : '',
      alt: cleanGalleryAlt(alt) || P.title || ''
    };
  }

  function imageUrl(media) {
    return typeof media === 'string' ? media : media && media.url;
  }

  function imageMatchesSelection(media) {
    var tags = parseGalleryTags(media && media.alt);
    var hasColor = !!tags.color;
    var hasSize = !!tags.size;

    if (tags.all === 'true') return true;
    if (!hasColor && !hasSize) return false;
    if (hasColor && normalizeTag(tags.color) !== normalizeTag(CURRENT_COLOR)) return false;
    if (hasSize && normalizeTag(tags.size) !== normalizeTag(CURRENT_SIZE)) return false;

    return true;
  }

  function parseGalleryTags(alt) {
    var tags = {};
    if (!alt) return tags;

    var marker = String(alt).match(/cp-gallery\s*:(.*)$/i);
    if (!marker) return tags;

    marker[1].split(/[;|]/).forEach(function (part) {
      var pair = part.split(/\s*[:=]\s*/);
      if (pair.length < 2) return;
      var key = pair[0].trim().toLowerCase();
      var value = pair.slice(1).join('=').trim();
      if (key === 'colour') key = 'color';
      if (key === 'color' || key === 'size') tags[key] = value;
      if (key === 'all') tags[key] = normalizeTag(value) === 'true' ? 'true' : 'false';
    });

    return tags;
  }

  function normalizeTag(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function cleanGalleryAlt(alt) {
    return String(alt || '').replace(/\s*cp-gallery\s*:.*$/i, '').trim();
  }

  function renderGallery() {
    var imgs = galleryImagesForCurrentSelection();
    var thumbs = $('cp-thumbs');
    thumbs.innerHTML = '';
    if (imgs.length === 0) return;

    var main = $('cp-main-image');
    main.src = imgs[0].url;
    main.alt = imgs[0].alt || P.title;

    imgs.forEach(function (img, i) {
      var el = document.createElement('div');
      el.className = 'cp-gallery__thumb' + (i === 0 ? ' is-active' : '');
      el.innerHTML = '<img src="' + escapeAttr(img.url) + '" alt="' + escapeAttr(img.alt || '') + '" loading="lazy">';
      el.addEventListener('click', function () {
        setMainImage(i, img);
      });
      thumbs.appendChild(el);
    });
  }

  function setMainImage(index, img) {
    $('cp-main-image').src = imageUrl(img);
    $('cp-main-image').alt = (img && img.alt) || P.title || '';
    var thumbs = document.querySelectorAll('.cp-gallery__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', i === index);
    }
  }

  function renderSizeSelector() {
    if (SIZES_ORDERED.length <= 1 && (SIZES_ORDERED[0] === 'Default' || !SIZES_ORDERED[0])) {
      $('cp-size-selector').style.display = 'none';
      return;
    }
    $('cp-size-selector').style.display = '';

    var container = $('cp-size-options');
    container.innerHTML = '';
    SIZES_ORDERED.forEach(function (size) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cp-size-btn' + (size === CURRENT_SIZE ? ' is-selected' : '');
      btn.textContent = size;
      btn.addEventListener('click', function () { selectSize(size); });
      container.appendChild(btn);
    });
    $('cp-size-value').textContent = CURRENT_SIZE || '';

    // Size-guide link visibility
    if (sizeGuideKeyFor(P.handle)) {
      var link = $('cp-size-guide-link');
      link.style.display = '';
      link.addEventListener('click', openSizeGuideAccordion);
    }
  }

  function selectSize(size) {
    CURRENT_SIZE = size;
    var avail = COLORS_BY_SIZE[size] || [];
    if (avail.indexOf(CURRENT_COLOR) === -1) CURRENT_COLOR = avail[0] || null;
    $('cp-size-value').textContent = size;
    var buttons = document.querySelectorAll('.cp-size-btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle('is-selected', buttons[i].textContent === size);
    }
    renderColorSelector();
    renderGallery();
    updatePrice();
    updateMainImage();
  }

  function renderColorSelector() {
    var colors = COLORS_BY_SIZE[CURRENT_SIZE] || [];
    if (colors.length <= 1 && (colors[0] === 'Default' || !colors[0])) {
      $('cp-color-selector').style.display = 'none';
      return;
    }
    $('cp-color-selector').style.display = '';

    var container = $('cp-color-options');
    container.innerHTML = '';
    colors.forEach(function (color) {
      var hex = (window.CP_getColorHex && window.CP_getColorHex(color)) || '#cccccc';
      var sw = document.createElement('span');
      sw.className = 'cp-color-swatch' + (color === CURRENT_COLOR ? ' is-selected' : '');
      sw.style.background = hex;
      sw.setAttribute('data-name', color);
      sw.setAttribute('role', 'button');
      sw.setAttribute('tabindex', '0');
      sw.setAttribute('aria-label', 'Select color ' + color);
      sw.addEventListener('click', function () { selectColor(color); });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectColor(color); }
      });
      container.appendChild(sw);
    });
    $('cp-color-value').textContent = CURRENT_COLOR || '';
  }

  function selectColor(color) {
    CURRENT_COLOR = color;
    $('cp-color-value').textContent = color;
    var swatches = document.querySelectorAll('.cp-color-swatch');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.toggle('is-selected', swatches[i].getAttribute('data-name') === color);
    }
    renderGallery();
    updatePrice();
    updateMainImage();
  }

  function updatePrice() {
    var v = currentVariant();
    var priceEl = $('cp-price-display');
    var noteEl = $('cp-price-note');
    if (v && typeof v.price === 'number') {
      priceEl.textContent = '$' + v.price.toFixed(2);
      noteEl.textContent = 'Reference price';
    } else {
      if (P.priceMin === P.priceMax) {
        priceEl.textContent = '$' + P.priceMin.toFixed(2);
      } else {
        priceEl.textContent = 'From $' + P.priceMin.toFixed(2);
      }
      noteEl.textContent = 'Price varies by size';
    }
    updateBuyState(v);
    updateVariantUrl(v);
  }

  function updateVariantUrl(v) {
    if (!v || !window.history || !window.history.replaceState) return;

    try {
      var url = new URL(window.location.href);
      var size = v.size || 'Default';
      var color = v.color || 'Default';
      if (
        normalizeTag(url.searchParams.get('size')) === normalizeTag(size) &&
        normalizeTag(url.searchParams.get('color')) === normalizeTag(color) &&
        !url.searchParams.has('variant')
      ) return;

      url.searchParams.delete('variant');
      url.searchParams.set('size', size);
      url.searchParams.set('color', color);
      window.history.replaceState({ variantId: v.id, size: size, color: color }, '', url.toString());
    } catch (e) {
      // URL syncing is progressive enhancement; selectors still work without it.
    }
  }

  function bindQuantityButtons() {
    var qtyInput = $('cp-quantity');
    if (!qtyInput) return;

    document.querySelectorAll('[data-cp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-cp-qty'), 10) || 0;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = next;
      });
    });
  }

  function updateBuyState(v) {
    var idInput = $('cp-variant-id');
    var button = $('cp-add-to-cart');
    var meta = $('cp-buy-meta');
    if (!button) return;

    if (v && idInput) idInput.value = v.id;

    if (!v) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Unavailable';
      if (meta) meta.textContent = 'Please select an available option.';
      return;
    }

    if (v.available) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.textContent = 'Add to Cart';
      if (meta) meta.textContent = 'Ships when available. Secure checkout powered by Shopify.';
    } else {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Sold Out';
      if (meta) meta.textContent = 'This selection is currently unavailable.';
    }
  }

  function updateMainImage() {
    var v = currentVariant();
    if (v && v.image) {
      $('cp-main-image').src = v.image;
      // Highlight the matching thumb if it exists
      var thumbs = document.querySelectorAll('.cp-gallery__thumb img');
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('src') === v.image) {
          var thumbEls = document.querySelectorAll('.cp-gallery__thumb');
          for (var j = 0; j < thumbEls.length; j++) thumbEls[j].classList.toggle('is-active', j === i);
          break;
        }
      }
    }
  }

  function renderAccordion() {
    var acc = $('cp-accordion');
    if (!acc) return;

    var items = [];

    // Description
    items.push({
      title: 'Description',
      open: true,
      html: P.description || ''
    });

    // Fit & Sizing (only for products with a size guide)
    var sgKey = sizeGuideKeyFor(P.handle);
    if (sgKey && window.CP_SIZE_DATA && window.CP_SIZE_DATA[sgKey]) {
      items.push({
        title: 'Fit & Sizing',
        open: false,
        html: '<div data-size-guide="' + sgKey + '" id="cp-size-guide"></div>'
      });
    }

    // Care Instructions
    items.push({
      title: 'Care Instructions',
      open: false,
      html:
        '<ul>' +
        '<li>Machine wash cold on gentle cycle</li>' +
        '<li>Tumble dry low to preserve softness</li>' +
        '<li>Wash separately before first use; do not bleach</li>' +
        '<li>OEKO-TEX certified — safe for the whole family</li>' +
        '</ul>'
    });

    acc.innerHTML = items.map(function (it) {
      return (
        '<div class="cp-accordion__item' + (it.open ? ' is-open' : '') + '">' +
          '<button type="button" class="cp-accordion__header">' + escapeHtml(it.title) + '</button>' +
          '<div class="cp-accordion__body">' + it.html + '</div>' +
        '</div>'
      );
    }).join('');

    // Toggle handlers
    acc.querySelectorAll('.cp-accordion__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.parentElement.classList.toggle('is-open');
      });
    });

    // Initialize size guide widget(s) inside the accordion
    if (window.CP_renderSizeGuide) {
      acc.querySelectorAll('[data-size-guide]').forEach(function (el) {
        window.CP_renderSizeGuide(el, el.getAttribute('data-size-guide'));
      });
    }
  }

  function openSizeGuideAccordion(e) {
    if (e) e.preventDefault();
    var acc = $('cp-accordion');
    if (!acc) return;
    acc.querySelectorAll('.cp-accordion__item').forEach(function (item) {
      if (item.querySelector('[data-size-guide]')) {
        item.classList.add('is-open');
        item.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
  }

  function renderRelated() {
    var grid = $('cp-related-grid');
    if (!grid) return;
    var related = P.related || [];
    if (related.length === 0) {
      grid.innerHTML = '';
      return;
    }
    grid.innerHTML = related.map(function (r) {
      var fromHtml = (r.priceMin !== r.priceMax) ? '<span class="cp-card__from">From</span>' : '';
      var img = r.image || '';
      return (
        '<a href="' + escapeAttr(r.url) + '" class="cp-card">' +
          '<div class="cp-card__image-wrap">' +
            (img ? '<img class="cp-card__image" src="' + escapeAttr(img) + '" alt="' + escapeAttr(r.title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="cp-card__info">' +
            '<div class="cp-card__type">' + escapeHtml(r.type) + '</div>' +
            '<div class="cp-card__name">' + escapeHtml(r.title) + '</div>' +
            '<div class="cp-card__meta">' +
              '<div class="cp-card__price-block">' +
                fromHtml +
                '<span class="cp-card__price">$' + r.priceMin.toFixed(2) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</a>'
      );
    }).join('');
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
